import { get, writable } from 'svelte/store';
import { navigate } from '../../app.logic';
import { ClassroomService } from '../../services/classroom.service';
import { ReportsService } from '../../services/reports.service';
export const loading = writable(false);
export const filter = writable({ criteria: {} });
export const records = writable([]);
export const pagination = writable(null);
export const record = writable(null);
export const stats = writable(null);
export const participants = writable([]);
export const selectedParticipantId = writable(0);
export const importDiagnostics = writable(null);
export async function initList() {
    filter.set({ criteria: {}, params: null, sorting: "" });
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    record.set(null);
    await load();
}
export async function initDetail(oid) {
    record.set(null);
    //stats.set(null);
    if (oid == 0) {
        record.set({ oid: 0, code: '', name: '', clfCompilerId: 0 });
    }
    else {
        let _resp = await ClassroomService.fetchClassroom(oid);
        record.set(_resp.payload);
        //await loadStats(oid);
        loadParticipants(oid);
    }
}
async function loadStats(classroomOid) {
    //let _resp = await ClassroomService.fetchClassroomStats(classroomOid);
    //stats.set(_resp.payload);
}
async function loadParticipants(classroomId) {
    let _resp = await ClassroomService.getClassroomParticipants(classroomId);
    participants.set(_resp.payload);
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await ClassroomService.getClassrooms(_filter, _pag.currentPage);
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate() {
    // console.log("onCreate");
    navigate(`/classroom/0`);
}
export function onEdit(item) {
    // console.log("onEdit", item);
    navigate(`/classroom/${item.oid}`);
}
export async function save() {
    let _record = get(record);
    return await ClassroomService.saveClassroom(_record);
}
export async function onDelete(item) {
    // console.log("onDelete", item);
    await ClassroomService.deleteClassroom(item.oid);
    await load();
}
export function onPageChange(pageNumber) {
    // console.log("onPageChange: " + pageNumber);
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
// Members
export async function onAddParticipant(classroomId, userId) {
    let _record = {
        oid: 0,
        portalUserId: userId,
        classroomId: classroomId
    };
    selectedParticipantId.set(0);
    let ret = await ClassroomService.saveClassroomParticipant(_record);
    await initDetail(classroomId);
    return ret;
}
export async function onDeleteParticipant(item) {
    // console.log("onDelete", item);
    selectedParticipantId.set(0);
    await ClassroomService.deleteClassroomParticipant(item.oid);
    await initDetail(item.classroomId);
}
// Whole Classroom Deletion
export async function deleteWholeClassroom() {
    let _record = get(record);
    await ClassroomService.deleteClassroomAndMembers(_record.oid);
    navigate(`/classroom`);
}
export function onClassroomExport() {
    let _record = get(record);
    ReportsService.exportExcelClassroom(_record.oid);
}
export async function onClassroomUpload(evt) {
    let _record = get(record);
    let file = evt.detail;
    importDiagnostics.set(null);
    if (file != null) {
        let _res = await ClassroomService.uploadClassroomExcel(_record.oid, file);
        importDiagnostics.set(_res.payload.messages);
    }
    await loadParticipants(_record.oid);
}
